import React, { useEffect, useState } from 'react';

// bootstrap
import { Col, Row } from "react-bootstrap";

// tremor
import { Subtitle } from "@tremor/react";

// drop down menu
import Select from "react-select";

// styling
import { Spacing } from "_styles";

// redux
import { selectDropOffLocations, selectPickUpLocations } from "_redux/slices/timeline/timeline-areas";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { selectSelectedTask, selectSelectedMultiplePAXTask, } from "_redux/slices/timeline/selected-task";
import { selectDefaultArrivalCheckInLocation, selectDefaultCheckInLocation } from "_redux/slices/timeline/timeline-control";
import { selectFirebaseInfo } from "_redux/slices/main-screen/user";
import { selectUsedTheme } from '_redux/slices/timeline/theme';

const PickupDropOffDropDowns = (props) => {

    // local states

    // redux
    const dropOffLocations = useSelector(selectDropOffLocations);                 // airport drop off locations
    const pickUpLocations = useSelector(selectPickUpLocations);                   // airport pick up locations
    const selectedTask = useSelector(selectSelectedTask);                         // selected task from the job list
    const selectedMultiplePAXTask = useSelector(selectSelectedMultiplePAXTask);   // selected task with multiple pax from the job list

    const defaultCheckInLocation = useSelector(selectDefaultCheckInLocation)      // default check in location from the timeline data
    const defaultArrivalCheckInLocation = useSelector(selectDefaultArrivalCheckInLocation)      // default arrival check in location from the timeline data
    const usedTheme = useSelector(selectUsedTheme);

    // airport
    const dbUser = useSelector(selectFirebaseInfo);
    const iata = dbUser?.details?.authority;

    const [totalPickUpObj, setTotalPickUpObj] = useState(null);
    const [totalDropOffObj, setTotalDropOffObj] = useState(null);
    const [multiplePickUpOptions, setMultiplePickUpOptions] = useState([]);
    const [multipleDropOffOptions, setMultipleDropOffOptions] = useState([]);


    useEffect(() => {
        // check if there is a flight doc
        if (props?.flightDocument != null) {

            // try get gate / stand from flight doc
            let flightGate = props?.flightDocument?.gate;
            let flightStand = props?.flightDocument?.stand;
            let flightType = props?.flightDocument?.type;
            let pickup = ''
            let dropoff = ''

            if (flightType == 'arrival') {


                // if arrival check in location is set, it is set to be drop of for ramp and pickup for normal arrival
                if (defaultArrivalCheckInLocation) {
                    if (selectedTask?.combinedRampBooking) {
                        dropoff = matchLocationById(pickUpLocations, defaultArrivalCheckInLocation);
                        pickup = props?.selectedEmployee?.role === "driver"
                            ? matchLocationByStandOrGate(pickUpLocations, flightGate, flightStand)
                            : matchLocationByGateOrStand(pickUpLocations, flightGate, flightStand);

                    } else {
                        pickup = matchLocationById(pickUpLocations, defaultArrivalCheckInLocation);
                    }
                }
                // if arrival pax checkin at holding
                else if (selectedTask?.originalBookingDoc?.arrivalPaxCheckIn) {
                    let pickupLocId = selectedTask?.originalBookingDoc?.arrivalPaxCheckIn?.locationId;
                    let foundPickup = pickUpLocations?.find(l => l?._id == pickupLocId);
                    pickup = foundPickup;
                }
                // if ramp booking or driver, try find corresponding location for stand / gate
                else if (selectedTask?.combinedRampBooking || props?.selectedEmployee?.role === "driver") {
                    pickup = matchLocationByStandOrGate(dropOffLocations, flightGate, flightStand);
                }
                // fallback for normal arrival task - check if is ramptask
                else {
                    // check if airbirdge or not

                    // check if dublin
                    if (iata == 'DUB') {
                        if (props?.flightDocument?.stand === "409C") {
                            // for dublin when the stand is 409C, use the gate 407
                            pickup = matchLocationByGateOrStand(pickUpLocations, "407", flightStand);

                        } else if (props?.flightDocument?.airbridgeInUse == false) {
                            // check if airbridge
                            pickup = matchLocationByHoldingArea(pickUpLocations, props.flightDocument)
                        }
                        else if (props?.flightDocument?.isRampTask) {
                            pickup = matchLocationByHoldingArea(pickUpLocations, props.flightDocument)
                        }
                        else {
                            // use gate / stand as pickup
                            pickup = matchLocationByGateOrStand(pickUpLocations, flightGate, flightStand);
                        }
                    }
                    else {
                        // need to use gate / airbridge is being used
                        pickup = matchLocationByGateOrStand(pickUpLocations, flightGate, flightStand);
                    }
                }

                // connection passenger: set drop-off to the onwards departure flight gate
                if (selectedTask?.originalBookingDoc?.onwards && props?.connectionFlightData?.connectionFlight) {
                    const cf = props.connectionFlightData.connectionFlight;
                    const onwardsDropoff = matchLocationByGateOrStand(dropOffLocations, cf.gate, cf.stand);
                    if (onwardsDropoff) dropoff = onwardsDropoff;
                }

            }
            else if (flightType == 'departure' || flightType == 'boarding') {



                // need to set dropoff location based on stand / gate
                // try find corresponding location for gate / stand
                dropoff = matchLocationByGateOrStand(dropOffLocations, flightGate, flightStand);
                // check if passenger has checked in 



                // check if booking is combined
                if (selectedTask?.combinedBooking || selectedTask?.combinedMarshallBooking) {
                    pickup = matchLocationByGateOrStand(pickUpLocations, flightGate, flightStand);
                    // boarding dropoff location is the same as the stand
                    dropoff = (props?.selectedEmployee?.role === "driver" || (iata === "BFS" && props?.selectedEmployee?.role === "cca"))
                        ? matchLocationByStandOrGate(dropOffLocations, flightGate, flightStand)
                        : matchLocationByGateOrStand(dropOffLocations, flightGate, flightStand);
                    // if (!dropoff) {
                    //     // if not stand get the gate location
                    //     dropoff = matchLocationByGateOrStand(dropOffLocations, flightGate, flightStand);
                    // }

                }
                // check if pax has checked in
                else if (selectedTask?.paxPositionInfo?.activity === "Checked-in") {

                    // get check in locaiton
                    let checkinLocation = selectedTask?.paxPositionInfo?.locationId;
                    // try find corresponding location for gate / stand
                    pickup = pickUpLocations?.find(loc => loc?._id === checkinLocation);

                }
                // check if this is an ALT pickup or gate relocation task
                else if (selectedTask?.isALTPickUp || selectedTask?.isGateRelocation) {
                    // Handle ALT pickup and gate relocation tasks
                    if (selectedTask?.pickUpLocation?.id) {
                        pickup = matchLocationById(pickUpLocations, selectedTask?.pickUpLocation?.id)
                    };
                    if (selectedTask?.dropOffLocation?.id) {
                        dropoff = matchLocationById(dropOffLocations, selectedTask?.dropOffLocation?.id)
                    }
                }
                // if no combined booking, check in location or ALT pickup or gate relocation task
                else {

                    // check if pax has location (like alt pickup)
                    if (selectedTask?.paxPositionInfo?.locationId) {
                        // try find corresponding location for gate / stand
                        pickup = matchLocationByGateOrStand(pickUpLocations, selectedTask?.paxPositionInfo?.locationId);
                    } else {
                        // no location set
                        if (defaultCheckInLocation) {
                            // use default checkin location
                            pickup = pickUpLocations?.find(loc => loc?._id === defaultCheckInLocation);
                        }
                        else {
                            pickup = null
                        }
                    }

                }
            }

            // set states using pickup / dropoff
            if (pickup) {
                props.setSelectedPickUp(pickup?._id);
                setTotalPickUpObj(pickup);
            } else {
                props.setSelectedPickUp(null);
                setTotalPickUpObj(null);
            }
            if (dropoff) {
                props.setSelectedDropOff(dropoff?._id);
                setTotalDropOffObj(dropoff);
            } else {
                props.setSelectedDropOff(null);
                setTotalDropOffObj(null);
            }

        } else {
            // No flight document - check if this is a gate relocation or ALT pickup task with location data
            if (selectedTask?.isGateRelocation || selectedTask?.isALTPickUp) {
                let pickup = null;
                let dropoff = null;

                if (selectedTask?.pickUpLocation?.id) {
                    pickup = matchLocationById(pickUpLocations, selectedTask?.pickUpLocation?.id);
                }
                if (selectedTask?.dropOffLocation?.id) {
                    dropoff = matchLocationById(dropOffLocations, selectedTask?.dropOffLocation?.id);
                }

                if (pickup) {
                    props.setSelectedPickUp(pickup?._id);
                    setTotalPickUpObj(pickup);
                } else {
                    props.setSelectedPickUp(null);
                    setTotalPickUpObj(null);
                }
                if (dropoff) {
                    props.setSelectedDropOff(dropoff?._id);
                    setTotalDropOffObj(dropoff);
                } else {
                    props.setSelectedDropOff(null);
                    setTotalDropOffObj(null);
                }
            } else if (selectedTask?.paxPositionInfo?.activity === 'Checked-in' && selectedTask?.paxPositionInfo?.locationId) {
                // Pax is already checked in (e.g. RC pax) but flight document hasn't loaded —
                // set pickup from the check-in location so it's not blank
                const checkinLocation = selectedTask.paxPositionInfo.locationId;
                const pickup = pickUpLocations?.find(loc => loc?._id == checkinLocation);
                if (pickup) {
                    props.setSelectedPickUp(pickup?._id);
                    setTotalPickUpObj(pickup);
                } else {
                    props.setSelectedPickUp(null);
                    setTotalPickUpObj(null);
                }
                props.setSelectedDropOff(null);
                setTotalDropOffObj(null);
            } else {
                props.setSelectedPickUp(null);
                props.setSelectedDropOff(null);
                setTotalPickUpObj(null);
                setTotalDropOffObj(null);
            }
        }
    }, [props?.flightDocument, selectedTask, pickUpLocations, dropOffLocations, props?.connectionFlightData])

    // New useEffect to check for multiple pickup locations with same gate/stand
    useEffect(() => {
        // Only check if locations array is populated and stable
        if (totalPickUpObj && props?.flightDocument && Array.isArray(pickUpLocations) && pickUpLocations.length > 0) {
            const flightGate = props?.flightDocument?.gate;
            const flightStand = props?.flightDocument?.stand;

            // Use gate/stand from flight document or from the location object
            const gateToCheck = totalPickUpObj?.gate || flightGate;
            const standToCheck = totalPickUpObj?.stand || flightStand;

            // Check if there are multiple locations with the same gate or stand
            const matchingLocations = checkMultipleLocationsByGateOrStand(
                pickUpLocations,
                gateToCheck,
                standToCheck
            );

            if (matchingLocations.length > 1) {
                setMultiplePickUpOptions(matchingLocations);
            } else {
                setMultiplePickUpOptions([]);
            }
        } else {
            setMultiplePickUpOptions([]);
        }
    }, [totalPickUpObj, props?.flightDocument, pickUpLocations, selectedTask]);

    // New useEffect to check for multiple dropoff locations with same gate/stand
    useEffect(() => {
        // Only check if locations array is populated and stable
        if (totalDropOffObj && props?.flightDocument && Array.isArray(dropOffLocations) && dropOffLocations.length > 0) {
            const flightGate = props?.flightDocument?.gate;
            const flightStand = props?.flightDocument?.stand;

            // Use gate/stand from flight document or from the location object
            const gateToCheck = totalDropOffObj?.gate || flightGate;
            const standToCheck = totalDropOffObj?.stand || flightStand;

            // Check if there are multiple locations with the same gate or stand
            const matchingLocations = checkMultipleLocationsByGateOrStand(
                dropOffLocations,
                gateToCheck,
                standToCheck
            );

            if (matchingLocations.length > 1) {
                setMultipleDropOffOptions(matchingLocations);
            } else {
                setMultipleDropOffOptions([]);
            }
        } else {
            setMultipleDropOffOptions([]);
        }
    }, [totalDropOffObj, props?.flightDocument, dropOffLocations, selectedTask]);


    // match arrival flight to the corresppnding holding area
    const matchLocationByHoldingArea = (locations, flightDocument) => {
        let foundLocation = null;

        // check if flight is t1 or t2
        let terminal = flightDocument?.terminal.trim() ?? '';

        // check if t1
        if (terminal === 'T1' || terminal === '1') {
            // match to t1 holding area (218)
            foundLocation = locations?.find(loc => loc?.title === '218');
        }
        else {
            // match to t2 holding area (Ramp 407)
            foundLocation = locations?.find(loc => loc?.title === 'Ramp 407');
        }

        return foundLocation;
    }

    const matchLocationByGateOrStand = (locations, gate, stand) => {

        let foundLocation = null;

        foundLocation = locations?.find(loc => (loc?.gate && loc?.gate?.trim() == gate?.trim()));


        if (Object.isObjectEmpty(foundLocation)) {

            foundLocation = locations?.find(loc => (loc?.stand && loc?.stand?.trim() == stand?.trim()));
        };

        return foundLocation;
    };

    // New function to check for multiple locations with same gate or stand
    const checkMultipleLocationsByGateOrStand = (locations, gate, stand) => {
        // Ensure locations is an array
        if (!Array.isArray(locations) || locations.length === 0) {
            return [];
        }

        let foundLocations = [];

        // First try by gate
        if (gate && gate.trim()) {

            foundLocations = locations.filter(loc => (loc?.gate && loc?.gate?.trim() == gate?.trim())) || [];
        }

        // If no gate matches, try by stand
        if (foundLocations.length === 0 && stand && stand.trim()) {
            foundLocations = locations.filter(loc => (loc?.stand && loc?.stand?.trim() == stand?.trim())) || [];
        }

        return foundLocations;
    };

    const matchLocationByStandOrGate = (locations, gate, stand) => {
        let foundLocation = null;

        // foundLocation = locations?.find(loc => (loc?.gate && loc?.gate?.trim() == gate?.trim()));
        foundLocation = locations?.find(loc => (loc?.stand && loc?.stand?.trim() == stand?.trim()));

        if (Object.isObjectEmpty(foundLocation)) {
            foundLocation = locations?.find(loc => (loc?.gate && loc?.gate?.trim() == gate?.trim()));
        };
        return foundLocation;
    };

    // New function to check for multiple locations with same stand or gate
    const checkMultipleLocationsByStandOrGate = (locations, gate, stand) => {
        let foundLocations = [];

        // First try by stand
        if (stand) {
            foundLocations = locations?.filter(loc => (loc?.stand && loc?.stand?.trim() == stand?.trim())) || [];
        }

        // If no stand matches, try by gate
        if (foundLocations.length === 0 && gate) {
            foundLocations = locations?.filter(loc => (loc?.gate && loc?.gate?.trim() == gate?.trim())) || [];
        }

        return foundLocations;
    };

    const matchLocationById = (locations, locationId) => {
        return locations?.find(loc => loc?._id == locationId);
    }

    const formatSelectValue = (type, id) => {
        if (type == "pickUp") {
            // return pickUpLocations?.find(loc => loc?._id == id);
            let tempPickUp = pickUpLocations?.find(loc => loc?._id == id);
            if (tempPickUp) {
                return {
                    value: tempPickUp?._id,
                    label: tempPickUp?.title
                }
            } else {
                return null;
            }
        } else if (type == "dropOff") {
            // return dropOffLocations?.find(loc => loc?._id == id);
            let tempDropOff = dropOffLocations?.find(loc => loc?._id == id);
            if (tempDropOff) {
                return {
                    value: tempDropOff?._id,
                    label: tempDropOff?.title
                }
            } else {
                return null;
            }
        }
    }

    const getSelectStyles = () => ({
        control: (provided, state) => ({
            ...provided,
            minWidth: "25%",
            borderRadius: "5px",
            backgroundColor: usedTheme.BACKGROUND_COLOR,
            borderColor: usedTheme.BORDER_COLOR,
            color: usedTheme.TEXT_COLOR,
            boxShadow: state.isFocused ? `0 0 0 1px ${usedTheme.BORDER_COLOR}` : 'none',
            '&:hover': {
                borderColor: usedTheme.BORDER_COLOR,
            },
        }),
        placeholder: (provided) => ({
            ...provided,
            color: usedTheme.TEXT_COLOR,
        }),
        singleValue: (provided) => ({
            ...provided,
            color: usedTheme.TEXT_COLOR,
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: usedTheme.BACKGROUND_COLOR,
            border: `1px solid ${usedTheme.BORDER_COLOR}`,
            zIndex: 5,
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused
                ? usedTheme.BORDER_COLOR
                : usedTheme.BACKGROUND_COLOR,
            color: usedTheme.TEXT_COLOR,
            cursor: 'pointer',
        }),
        input: (provided) => ({
            ...provided,
            color: usedTheme.TEXT_COLOR,
        }),
    });

    const handlePickUpSelection = (locationId) => {
        props.setSelectedPickUp(locationId);
        const selectedLocation = multiplePickUpOptions.find(loc => loc._id === locationId);
        setTotalPickUpObj(selectedLocation);
        setMultiplePickUpOptions([]);
    };

    const handleDropOffSelection = (locationId) => {
        props.setSelectedDropOff(locationId);
        const selectedLocation = multipleDropOffOptions.find(loc => loc._id === locationId);
        setTotalDropOffObj(selectedLocation);
        setMultipleDropOffOptions([]);
    };

    return (
        <Row>

            {/* select pick up + drop off location */}
            <Col xs={12} md={6} lg={6}>
                <div>
                    <Subtitle>Pick Up Location</Subtitle>
                    <Select
                        value={formatSelectValue("pickUp", props.selectedPickUp)}
                        onChange={(selectedOption) => props.setSelectedPickUp(selectedOption?.value)}
                        options={pickUpLocations?.map(loc => ({ value: loc._id, label: loc.title }))}
                        placeholder="Choose Pick Up Location..."
                        isClearable
                        styles={getSelectStyles()}
                    />
                    {multiplePickUpOptions.length > 0 && (
                        <div style={{ marginTop: Spacing.SCALE_8 }}>
                            <div style={{
                                color: '#ff9800',
                                fontSize: '12px',
                                marginBottom: Spacing.SCALE_8,
                                fontWeight: 'bold'
                            }}>
                                ⚠️ There are multiple locations with the same gate or stand. Please select the correct one.
                            </div>
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: Spacing.SCALE_8
                            }}>
                                {multiplePickUpOptions.map((location) => (
                                    <div
                                        key={location._id}
                                        onClick={() => handlePickUpSelection(location._id)}
                                        style={{
                                            padding: `${Spacing.SCALE_8} ${Spacing.SCALE_12}`,
                                            borderRadius: '20px',
                                            border: `2px solid ${usedTheme.BORDER_COLOR}`,
                                            backgroundColor: props.selectedPickUp === location._id
                                                ? usedTheme.BORDER_COLOR
                                                : usedTheme.BACKGROUND_COLOR,
                                            color: usedTheme.TEXT_COLOR,
                                            cursor: 'pointer',
                                            fontSize: '14px',
                                            transition: 'all 0.2s ease',
                                            fontWeight: props.selectedPickUp === location._id ? 'bold' : 'normal',
                                            paddingInline: Spacing.SCALE_20,
                                        }}
                                        onMouseEnter={(e) => {
                                            if (props.selectedPickUp !== location._id) {
                                                e.target.style.backgroundColor = usedTheme.BORDER_COLOR;
                                                e.target.style.opacity = '0.7';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (props.selectedPickUp !== location._id) {
                                                e.target.style.backgroundColor = usedTheme.BACKGROUND_COLOR;
                                                e.target.style.opacity = '1';
                                            }
                                        }}
                                    >
                                        {location.title}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </Col>
            <Col xs={12} md={6} lg={6} >
                <div>
                    <Subtitle>Drop Off Location</Subtitle>
                    <Select
                        value={formatSelectValue("dropOff", props.selectedDropOff)}
                        onChange={(selectedOption) => props.setSelectedDropOff(selectedOption?.value)}
                        options={dropOffLocations?.map(loc => ({ value: loc._id, label: loc.title }))}
                        placeholder="Choose Drop Off Location..."
                        styles={getSelectStyles()}
                        isClearable
                    />
                    {multipleDropOffOptions.length > 0 && (
                        <div style={{ marginTop: Spacing.SCALE_8 }}>
                            <div style={{
                                color: '#ff9800',
                                fontSize: '12px',
                                marginBottom: Spacing.SCALE_8,
                                fontWeight: 'bold'
                            }}>
                                ⚠️ There are multiple locations with the same gate or stand. Please select the correct one.
                            </div>
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: Spacing.SCALE_8
                            }}>
                                {multipleDropOffOptions.map((location) => (
                                    <div
                                        key={location._id}
                                        onClick={() => handleDropOffSelection(location._id)}
                                        style={{
                                            padding: `${Spacing.SCALE_8} ${Spacing.SCALE_12}`,
                                            borderRadius: '20px',
                                            border: `2px solid ${usedTheme.BORDER_COLOR}`,
                                            backgroundColor: props.selectedDropOff === location._id
                                                ? usedTheme.BORDER_COLOR
                                                : usedTheme.BACKGROUND_COLOR,
                                            color: usedTheme.TEXT_COLOR,
                                            cursor: 'pointer',
                                            fontSize: '14px',
                                            transition: 'all 0.2s ease',
                                            fontWeight: props.selectedDropOff === location._id ? 'bold' : 'normal',
                                            paddingInline: Spacing.SCALE_20,
                                        }}
                                        onMouseEnter={(e) => {
                                            if (props.selectedDropOff !== location._id) {
                                                e.target.style.backgroundColor = usedTheme.BORDER_COLOR;
                                                e.target.style.opacity = '0.7';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (props.selectedDropOff !== location._id) {
                                                e.target.style.backgroundColor = usedTheme.BACKGROUND_COLOR;
                                                e.target.style.opacity = '1';
                                            }
                                        }}
                                    >
                                        {location.title}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </Col>

        </Row>
    );
};

export default PickupDropOffDropDowns;
